// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"archive-products_wrapper__5TPxI","result":"archive-products_result__Tn8N1"};